import React, { useState } from 'react'
import { Box, Fade } from '@mui/material'
import { UserInterface } from '@/services/types/APIResponseType'
import close_icon from '@/assets/close_icon.svg'
import flip_icon from '@/assets/flip_v.svg'

interface IdProofPropsType {
  handleClickClose: () => void
  handleFlip: () => void
  isFlipped: boolean
  isModelOpen: boolean
  currentConsumer: UserInterface
}

const IdProofModel: React.FC<IdProofPropsType> = ({
  currentConsumer,
  isFlipped,
  isModelOpen,
  handleFlip,
  handleClickClose,
}) => {
  const [isClicked, setIsClicked] = useState<boolean>(false)
  return (
    <Fade in={isModelOpen}>
      <Box className="consumer-modal-style">
        <div className="model-close" onClick={handleClickClose}>
          <img src={close_icon} alt="Close" />
        </div>

        <div className="containers-popup">
          <div className="popup-heading">
            <h1>Government Issued ID</h1>
          </div>
          <img
            src={
              isFlipped
                ? currentConsumer?.profileInfo?.idFront
                  ? currentConsumer?.profileInfo?.idFront
                  : '/icon/Image.svg'
                : currentConsumer?.profileInfo?.idBack
                  ? currentConsumer?.profileInfo?.idBack
                  : '/icon/Image.svg'
            }
            alt={isFlipped ? 'proof-front' : 'proof-back'}
            className="id-proof"
          />
          <div
            className={`flip-btn `}
            onClick={() => {
              handleFlip()
              setIsClicked(true)
            }}
          >
            <img
              src={flip_icon}
              alt="flip"
              className={`cursor-pointer transition-transform duration-700 ease-in-out ${
                isClicked &&
                (!isFlipped ? 'animate-flip-left' : 'animate-flip-right')
              }`}
            />
          </div>
        </div>
      </Box>
    </Fade>
  )
}

export default IdProofModel
